// 帮助方法
import CryptoJS from 'crypto-js'

// 初始化城市代码映射，补充完整的城市代码
const CITY_MAP = {
  '11': '北京市',
  '12': '天津市',
  '13': '河北省',
  '14': '山西省',
  '15': '内蒙古自治区',
  '21': '辽宁省',
  '22': '吉林省',
  '23': '黑龙江省',
  '31': '上海市',
  '32': '江苏省',
  '33': '浙江省',
  '34': '安徽省',
  '35': '福建省',
  '36': '江西省',
  '37': '山东省',
  '41': '河南省',
  '42': '湖北省',
  '43': '湖南省',
  '44': '广东省',
  '45': '广西壮族自治区',
  '46': '海南省',
  '50': '重庆市',
  '51': '四川省',
  '52': '贵州省',
  '53': '云南省',
  '54': '西藏自治区',
  '61': '陕西省',
  '62': '甘肃省',
  '63': '青海省',
  '64': '宁夏回族自治区',
  '65': '新疆维吾尔自治区',
  '71': '台湾省',
  '81': '香港特别行政区',
  '82': '澳门特别行政区'
};

const REGEX_ID_CARD18 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9Xx])$/;

export default {
  // 下载excel文件
  excel: function (res, fileName) {
    let blob = new Blob([res], {type: 'application/x-xls'});
    const a = document.createElement('a');
    // 创建URL
    const blobUrl = window.URL.createObjectURL(blob);
    a.download = fileName + '.xlsx';
    a.href = blobUrl;
    document.body.appendChild(a);
    // 下载文件
    a.click();
    // 释放内存
    URL.revokeObjectURL(blobUrl);
    document.body.removeChild(a);
  },
  //生产uuid
  uuid: function () {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  },
  // 获取UTC日期的格式化字符串形式
  getUTCTime: function (formatString, date) {
    date = date || new Date()
    const o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds(), // 毫秒
      T: date.getTime() // 总毫秒
    }
    if (/(y+)/.test(formatString)) { // 年
      formatString = formatString.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(formatString)) {
        formatString = formatString.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return formatString
  },
  formatDateTime: function (val) {
    val = +val
    return !val ? '---' : this.getUTCTime('yyyy-MM-dd hh:mm:ss', new Date(val))
  },
  dateFormat: function (val, format) {
    val = +val
    return !val ? '---' : this.getUTCTime(format, new Date(val))
  },
  // 屏幕滚动
  scrollTop: (value) => {
    if (value) {
      document.documentElement.scrollTop = value
    } else {
      return document.documentElement.scrollTop
    }
  },
  // 手机号码验证
  phoneValid: (notRequired) => {
    return (rule, value, callback) => {
      const val = value.trim()
      const regExp = (/^[1][3456789]\d{9}$/)
      if (val === '' && !notRequired) {
        callback(new Error('请输入手机号码'))
      } else if (val && !regExp.test(val)) {
        callback(new Error('请正确输入手机号码'))
      } else {
        callback()
      }
    }
  },
  // 密码验证
  passwordValid: (message) => {
    return (rule, value, callback) => {
      const val = value.trim()
      // eslint-disable-next-line no-useless-escape
      const regExp = [/\d+/, /[a-z]+/, /[A-Z]+/, /[`~!@#$%^&*?=\-+_.,:''()<>|\/\[\]{}￥￡€ ]+/]
      const length = /\S{8,20}/
      let matches = 0
      regExp.forEach(item => {
        if (item.test(val)) {
          matches++
        }
      })
      if (val === '') {
        callback(new Error(message || '请输入密码'))
      } else if (matches < 3 || !length.test(val)) {
        callback(new Error('密码8-20位，至少包含数字，大写、小写和特殊字符中的三类'))
      } else {
        callback()
      }
    }
  },
  // 图形验证码验证
  captchaValid: (rule, value, callback) => {
    const val = value.trim()
    const regExp = (/^[0-9a-zA-Z]{4}$/)
    if (!val) {
      callback(new Error('请输入验证码'))
    } else if (!regExp.test(val)) {
      callback(new Error('验证码为4位数字或字母'))
    } else {
      callback()
    }
  },
  // md5加密
  md5: (val) => {
    return CryptoJS.MD5(val).toString()
  },
  // readFile
  readFile(file, resultType = 'dataUrl') {
    return new Promise((resolve) => {
      if (resultType === 'file') {
        resolve()
        return
      }
      const reader = new FileReader()
      reader.onload = (event) => {
        resolve(event.target.result)
      }
      if (resultType === 'dataUrl') {
        reader.readAsDataURL(file)
      } else if (resultType === 'text') {
        reader.readAsText(file)
      }
    })
  },
  /**
   * 检查输入是否匹配正则表达式
   * @param {string} regex - 正则表达式
   * @param {string} input - 输入字符串
   * @returns {boolean}
   */
  isMatch(regex, input) {
    return input && input.length > 0 && REGEX_ID_CARD18.test(input);
  },
  /**
   * 检查输入是否为 18 位身份证号格式
   * @param {string} input - 输入字符串
   * @returns {boolean}
   */
  isIDCard18(input) {
    return this.isMatch(REGEX_ID_CARD18, input)
  },

  /**
   * 精确检查 18 位身份证号
   * @param {string} input - 输入字符串
   * @returns {boolean}
   */
  isIDCard18Exact(input) {
    if (!this.isIDCard18(input)) {
      return false;
    }

    const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const suffix = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    const cityCode = input.substring(0, 2);
    if (!CITY_MAP[cityCode]) {
      return false;
    }

    let weightSum = 0;
    for (let i = 0; i < 17; i++) {
      weightSum += (input.charCodeAt(i) - '0'.charCodeAt(0)) * factor[i];
    }
    const idCardMod = weightSum % 11;
    const idCardLast = input[17].toUpperCase();
    return idCardLast === suffix[idCardMod];
  },
  /**
   * 校验是否是2-4个汉字
   * @param name
   * @returns {boolean}
   */
  checkChineseName(name) {
    // 匹配2-4个汉字
    const reg = /^[\u4e00-\u9fa5]{2,4}$/
    return reg.test(name)
  },
  /**
   * 校验手机号
   * @param phone
   * @returns {boolean}
   */
  checkPhone(phone) {
    const regExp = (/^[1][3456789]\d{9}$/)
    if (!regExp.test(phone)) {
      return false;
    }
    // 检查是否只包含3种或更少的数字
    const distinctNumbers = new Set(phone.split(''))
    if (distinctNumbers.size <= 3) {
      return false
    }

    // 检查是否有同一数字连续超过5次
    let currentChar = phone[0]
    let count = 1

    for (let i = 1; i < phone.length; i++) {
      if (phone[i] === currentChar) {
        count++
        if (count >= 5) {
          return false
        }
      } else {
        currentChar = phone[i]
        count = 1
      }
    }
    return true
  },
  //隐私协议
  getPrivacyProtocal() {
    return "https://www.mgadmob.com/dxjz-agreement.html"
  },
  //用户协议
  getUserProtocal() {
    return "https://www.mgadmob.com/dxjz-user.html"
  },
  //增值协议
  getFeeProtocal() {
    return "https://www.mgadmob.com/dxjz-service.html"
  },
  //跳转兼职直聘 h5 地址
  getJzzpH5Url() {
    return "http://m.jianzhime.com"
  },
  //下载 App 地址
  getDownloadAppUrl() {
    return "https://a.app.qq.com/o/simple.jsp?pkgname=com.miguan.jzzp"
  },
  isInMobileWx(){
    const ua = window.navigator.userAgent.toLowerCase();
    const isWechat = ua.indexOf('micromessenger') !== -1;
    if (!isWechat) return false; // 普通浏览器
    // 通过判断是否含有 mobile 标识来区分
    const isMobile = /mobile|android|iphone|ipad/i.test(ua);
    if (isMobile) {
      return true; // 手机版微信
    } else {
      return false;   // 电脑版微信 (Windows/Mac)
    }
  }


}
